<template>
    <div style="height: 100%">
        <div class="container">
            <div class="login">
                <img class="logo" src="../assets/logo.png" alt="Logo" width="100%">
                <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="login">
                    <el-form-item prop="username">
                        <el-input :placeholder="$t('用户名')" v-model="form.username" autofocus="true" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input :placeholder="$t('密码')" v-model="form.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="button" native-type="submit">{{$t('登录')}}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div style="position: absolute;top: 10px;right: 10px">
            <el-dropdown @command="changeLocale">
                <div class="el-dropdown-link">
                    {{$t('语言')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="zh">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div style="position: absolute;bottom: 0;line-height: 30px;width: 100%;text-align: center;font-size: 13px;">
            <a href="http://www.beian.miit.gov.cn" target="_blank" style="color: #000">京ICP备11038982号-11</a>
        </div>
    </div>
</template>

<i18n locale="en" lang="yaml">
    "用户名": "User Name"
    "密码": "Password"
    "登录": "Login"
    "语言": "Language"
    "请输入用户名": "Please input username"
    "请输入密码": "Please input password"
</i18n>

<script>
    import qs from 'qs';

    export default {
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                },
                rules: {
                    username: [
                        {required: true, message: this.$t('请输入用户名')}
                    ],
                    password: [
                        {required: true, message: this.$t('请输入密码')}
                    ],
                }
            }
        },
        methods: {
            login() {
                this.$utils.submit(this.$refs.form, "/login", qs.stringify(this.form), (data) => {
                    sessionStorage.setItem("auth-token", data);

                    this.$root.loadUserInfo().then(() => {
                        this.$root.loadMenus().then(() => {
                            this.redirect();
                        });
                    });
                });
            },
            redirect() {
                if (this.$root.user.type === 'USER') {
                    location.href = this.$root.services[0]['path'];
                } else {
                    this.$router.push("/index");
                }
            },
            changeLocale(local) {
                this.$i18n.locale = local;
                localStorage.setItem("local", local);
                this.$router.go(0);
            }
        }
    }
</script>
<style scoped>
    .container {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
    }

    .login {
        width: 300px;
        margin: 0 auto;
        text-align: center;
    }

    .button {
        width: 100%;
    }
</style>